import React, { useState, useEffect } from 'react';
import { DatePicker } from 'antd';
import locale from "antd/es/date-picker/locale/fr_FR";
import moment from 'moment';
import './DepassementModal.css';
import { ticketService } from '../../../../service/ticketService';
import dayjs from "dayjs";
const { RangePicker } = DatePicker;

const DepassementModal = ({ isOpen, onClose, onFilter }) => {
const [selectedMonthRange, setSelectedMonthRange] = useState([
  dayjs().startOf("month"),
  dayjs().endOf("month"),
]);
  const [etablissementsState, setEtablissementsState] = useState([]);

  // useEffect(() => {

  useEffect(() => {
    if (selectedMonthRange.length === 2) {
      const dateDebut = selectedMonthRange[0].startOf('month').format('YYYY-MM-DD');
      const dateFin = selectedMonthRange[1].endOf('month').format('YYYY-MM-DD');

      ticketService.getEstablishmentsWithMoreThanFourTickets({ dateDebut, dateFin })
        .then((data) => {

          return setEtablissementsState(data.data.result.etablissementsAvecDepassementNbreTicketsMois || []);
        }

        )
        .catch((error) => console.error('Error fetching establishments:', error));

      if (onFilter) onFilter({ dateBegin: dateDebut, dateEnd: dateFin });
    } else {
      if (onFilter) onFilter({ dateBegin: null, dateEnd: null });
    }
  }, [selectedMonthRange]);

  if (!isOpen) return null;

  const maxTickets = etablissementsState.length > 0
    ? Math.max(...etablissementsState.map(e => e.nombreTickets))
    : 0;

  const totalPDV = etablissementsState.length;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  const CloseIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  );

  const disabledDate = (current) => current && current > moment().endOf('month');

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-content">
        <div className="modal-header">
          <h2 className="modal-title">Établissements avec dépassement ({totalPDV})</h2>
          <button className="modal-close" onClick={onClose} aria-label="Fermer">
            <CloseIcon />
          </button>
        </div>

        <div className="modal-body">
          {/* Month Range Picker */}
          {/*  the modal of sleection not display at the front of this modal please fix it */}
          <RangePicker
            allowClear
            disabledDate={disabledDate}
            picker="month"
            locale={locale}
            value={selectedMonthRange}
            onChange={(dates) => setSelectedMonthRange(dates || [])}
            format="MM-YYYY"
            style={{ marginBottom: '20px', width: '100%', zIndex: 2100, position: 'relative', zIndex: 2100 }}
          />

          {/* <p style={{ fontWeight: 500, marginBottom: '12px' }}>Total PDV : {totalPDV}</p> */}

          {etablissementsState.length === 0 ? (
            <p>Aucun établissement n'a dépassé le nombre de tickets pour cette période.</p>
          ) : (
            <div className="establishment-list">
              {etablissementsState.map((etab, index) => {
                const percentage = maxTickets ? (etab.nombreTickets / maxTickets) * 100 : 0;
                return (
                  <div key={index} className="establishment-row">
                    <span className="establishment-name">{etab.nomEstablissement}</span>
                    <div className="progress-container">
                      <div className="progress-bar" style={{ width: `${percentage}%` }} />
                    </div>
                    <span className="ticket-count">{etab.nombreTickets} tickets</span>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DepassementModal;
